import {
  useState,
  useEffect,
} from 'react';
import moment from 'moment';
import Modal, { BaseModalBackground } from 'styled-react-modal';
import { Box, Button, Heading, Text, Flex } from 'rebass/styled-components';
import { ApolloClient } from '@apollo/client';
import { Constants } from '../utils/Constants';
import styled from 'styled-components';
import { useIdleTimer } from 'react-idle-timer'

const SpecialModalBackground = styled(BaseModalBackground)`
  backdrop-filter: blur(5px);
`
const SessionTimeout = ({ logout, client, heartbeat }: { heartbeat: () => Promise<void>, logout: () => void, client: ApolloClient<any>, lastLocationRef: string | null }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [lastTouch, setLastTouch] = useState<number | null>();

  const handleOnIdle = (event: Event | undefined) => {
    console.log('user is idle')
    // console.log('last active', getLastActiveTime())
    if (!isOpen) {
      heartbeat()
      setIsOpen(true)
    }
  }

  const handleOnActive = (event: Event | undefined) => {
    // console.log('user is active', event)
    // console.log('time remaining', getRemainingTime())
  }

  const handleOnAction = async (event: Event | undefined) => {
    if (!lastTouch || moment.unix(lastTouch).isBefore(moment().add(-5, 'minute'))) {
      await heartbeat()
      setLastTouch(moment().unix())
    }
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 45,// Constants.TIMEOUT_SESSION_WARNING_IN_MINUTES,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
    crossTab: true
  })
  const handleClose = async () => {
    await heartbeat()
    setLastTouch(moment().unix())
    setIsOpen(false)
  }

  if (!isOpen) {
    return null;
  }

  return (<ModalTimeout handleClose={handleClose} logout={logout} />)
};

const ModalTimeout = ({ logout, handleClose }: { logout: () => void, handleClose: () => void }) => {
  useEffect(() => {
    console.log('MT up')
    let to = setTimeout(() => {
    console.log('MT exp')

      logout()
    }, 1000 * 60 * 5);

    return () => clearTimeout(to)
  }, [])
  console.log('MT')

  return <Modal
    isOpen={true}
    onBackgroundClick={handleClose}
    onEscapeKeydown={handleClose}>
    <SpecialModalBackground>
      <Box style={{ margin: '0 auto', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
        <Heading mb={3}>Are you still here?</Heading>
        <Text mb={4} >Your session is about to expire. Close this modal to stay active.</Text>
        <Flex flexDirection={'row'} justifyContent='space-between' width={'100%'}>
          <Button variant={'pink'} onClick={logout} mt={4} >Log Me Out</Button>
          <Button variant={'primary'} onClick={handleClose} mt={4} >Continue</Button>
        </Flex>
        <Box onClick={handleClose} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
          X
        </Box>
      </Box>
    </SpecialModalBackground>
  </Modal>
}

export default SessionTimeout;